import {
  GET_EMPLOYEECONTRACTTYPE,
  GET_EMPLOYEECONTRACTTYPE_SUCCESS,
  GET_EMPLOYEECONTRACTTYPE_FAIL,
  DELETE_EMPLOYEECONTRACTTYPE,
  DELETE_EMPLOYEECONTRACTTYPE_SUCCESS,
  DELETE_EMPLOYEECONTRACTTYPE_FAIL,
  UPDATE_EMPLOYEECONTRACTTYPE,
  UPDATE_EMPLOYEECONTRACTTYPE_SUCCESS,
  UPDATE_EMPLOYEECONTRACTTYPE_FAIL,
  ADD_NEW_EMPLOYEECONTRACTTYPE,
  ADD_EMPLOYEECONTRACTTYPE_SUCCESS,
  ADD_EMPLOYEECONTRACTTYPE_FAIL,
  EMPLOYEECONTRACTTYPE_LOADING,
  EMPLOYEECONTRACTTYPE_RESET,
} from "./actionType";

export const resetEmployeeContractTypeState = (actionType) => ({
  type: EMPLOYEECONTRACTTYPE_RESET,
  payload: { actionType },
});

export const getEmployeeContractTypeSuccess = (actionType, data) => ({
  type: GET_EMPLOYEECONTRACTTYPE_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeContractTypeFail = (actionType, error) => ({
  type: GET_EMPLOYEECONTRACTTYPE_FAIL,
  payload: { actionType, error },
});

export const getEmployeeContractType = data => ({
  type: GET_EMPLOYEECONTRACTTYPE,
  payload: data,
});

export const getEmployeeContractTypeLoading = () => ({
  type: EMPLOYEECONTRACTTYPE_LOADING
});

export const deleteEmployeeContractType = data => ({
  type: DELETE_EMPLOYEECONTRACTTYPE,
  payload: data,
});

export const deleteEmployeeContractTypeSuccess = data => ({
  type: DELETE_EMPLOYEECONTRACTTYPE_SUCCESS,
  payload: data,
});

export const deleteEmployeeContractTypeFail = error => ({
  type: DELETE_EMPLOYEECONTRACTTYPE_FAIL,
  payload: error,
});

export const updateEmployeeContractType = data => ({
  type: UPDATE_EMPLOYEECONTRACTTYPE,
  payload: data,
});

export const updateEmployeeContractTypeFail = error => ({
  type: UPDATE_EMPLOYEECONTRACTTYPE_FAIL,
  payload: error,
});

export const updateEmployeeContractTypeSuccess = data => ({
  type: UPDATE_EMPLOYEECONTRACTTYPE_SUCCESS,
  payload: data,
});

export const addNewEmployeeContractType = data => ({
  type: ADD_NEW_EMPLOYEECONTRACTTYPE,
  payload: data,
});

export const addEmployeeContractTypeSuccess = data => ({
  type: ADD_EMPLOYEECONTRACTTYPE_SUCCESS,
  payload: data,
});

export const addEmployeeContractTypeFail = error => ({
  type: ADD_EMPLOYEECONTRACTTYPE_FAIL,
  payload: error,
});